import { PhoneNumberUtil } from 'google-libphonenumber';

/**
 * This regex comes from system-sdk v1. It was selected to match the regex used
 * in checkout-widget. Note that it allows for masked email addresses like
 * foo***@visa.com.
 *
 * https://stash.trusted.visa.com:7990/projects/DMPDUIE/repos/system-sdk/pull-requests/695/diff#src/helpers/is-email.js
 * https://stash.trusted.visa.com:7990/projects/THINWALLET/repos/checkout-widget/browse/src-widget/src/common/vco-component-identification/helpers/is-email.ts?at=refs%2Fheads%2Frelease-23.04.00
 *
 */
export const emailRegex =
  /^((([a-z]|\d|[!#\$%&\*\+\-\?_])+(\.([a-z]|\d|[!#\$%&\*\+\-\?_])*)*)*)@((([a-z]|\d)|(([a-z]|\d)([a-z]|\d|-|\.|_)*([a-z]|\d)))\.)+(([a-z])|(([a-z])([a-z]|\d|-|\.|_)*([a-z])))$/i;

// START GENAI@CHATGPT4
export const mobileRegex = /^\+?[1-9]\d{1,14}$/;
// END GENAI@CHATGPT4

export function isEmail(s: string) {
  return emailRegex.test(s);
}

export function isMobileFormatE164(s: string) {
  return mobileRegex.test(s);
}

//START GENAI@CHATGPT4
export function isValidNumber(phoneNumber: string): boolean {
  const finalPhoneNumber = phoneNumber[0] === '+' ? phoneNumber : `+${phoneNumber}`;
  const phoneUtil = PhoneNumberUtil.getInstance();

  try {
    const number = phoneUtil.parse(finalPhoneNumber);
    return phoneUtil.isValidNumber(number);
  } catch {
    return false;
  }
}
//END GENAI@CHATGPT4
